<svg class="D-menu-svg D-svg" width="16" height="16" {...$$props} ><path d="M0 8h16M0 2.665h16M0 13.335h16" stroke="currentColor" stroke-width="2"/></svg>